const OPEN_JOB_POSTING_PARAM = "open_job_posting";

function buildReturnUrl() {
  const baseUrl = window.location.pathname + window.location.search;
  const separator = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${separator}${OPEN_JOB_POSTING_PARAM}=true`;
}

function getUserSignedIn() {
  // eslint-disable-next-line no-underscore-dangle
  return (
    typeof window.__current_user_id !== "undefined"
    && window.__current_user_id != null
  );
}

function allowGuestJobPosting() {
  if (!document.body) return false;
  if (!document.body.dataset) return false;

  return document.body.dataset.jobPostingAllowGuest === "true";
}

function showSignInRequiredModal() {
  const el = document.getElementById("job-posting-sign-in-required");
  if (!el) return;

  const signUpPath = el.getAttribute("data-sign-up-path");
  const signInPath = el.getAttribute("data-sign-in-path");
  const returnUrl = buildReturnUrl();
  const encodedReturn = encodeURIComponent(returnUrl);

  const appendReturnTo = (path) => {
    const separator = path && path.includes("?") ? "&" : "?";
    return `${path || ""}${separator}return_to=${encodedReturn}`;
  };

  const signUpLink = el.querySelector(".job-posting-sign-in-required__sign-up");
  const signInLink = el.querySelector(".job-posting-sign-in-required__sign-in");
  if (signUpLink) signUpLink.href = appendReturnTo(signUpPath);
  if (signInLink) signInLink.href = appendReturnTo(signInPath);

  el.style.display = "flex";
  el.setAttribute("aria-hidden", "false");
  document.body.style.overflow = "hidden";
}

function hideSignInRequiredModal() {
  const el = document.getElementById("job-posting-sign-in-required");
  if (!el) return;

  el.style.display = "none";
  el.setAttribute("aria-hidden", "true");
  document.body.style.overflow = "";
}

// The job posting loader mounts asynchronously (React 18 createRoot), so an event
// dispatched here would be missed; the loader reads this flag on mount instead.
function consumeOpenJobPostingParam() {
  const url = new URL(window.location.href);
  const param = url.searchParams.get(OPEN_JOB_POSTING_PARAM);
  if (param !== "true" || (!getUserSignedIn() && !allowGuestJobPosting())) {
    return;
  }

  url.searchParams.delete(OPEN_JOB_POSTING_PARAM);
  const newUrl = url.pathname + url.search + url.hash;
  window.history.replaceState({}, document.title, newUrl);

  window.__openJobPostingOnLoad = true;
  // React 18 mounts this component asynchronously; fire after the loader can listen.
  setTimeout(() => {
    document.dispatchEvent(new CustomEvent("loadJobPosting", { bubbles: true }));
  }, 0);
}

function bindSignInRequiredModal() {
  const el = document.getElementById("job-posting-sign-in-required");
  if (!el) return;

  const close = () => {
    hideSignInRequiredModal();
  };

  const closeBtn = el.querySelector(".job-posting-sign-in-required__close");
  const overlay = el.querySelector(".job-posting-sign-in-required__overlay");
  if (closeBtn) closeBtn.addEventListener("click", close);
  if (overlay) overlay.addEventListener("click", close);
}

function interceptLoadJobPosting(e) {
  if (getUserSignedIn() || allowGuestJobPosting()) {
    return;
  }
  e.preventDefault();
  e.stopImmediatePropagation();
  showSignInRequiredModal();
}

const setupJobPosting = () => {
  bindSignInRequiredModal();

  document.removeEventListener("loadJobPosting", interceptLoadJobPosting, true);
  document.addEventListener("loadJobPosting", interceptLoadJobPosting, true);

  $(document)
    .off("click.jobPosting", ".job-posting-button")
    .on("click.jobPosting", ".job-posting-button", (e) => {
      e.preventDefault();

      if (getUserSignedIn() || allowGuestJobPosting()) {
        e.target.dispatchEvent(
          new CustomEvent("loadJobPosting", { bubbles: true }),
        );
      } else {
        showSignInRequiredModal();
      }
    });

  consumeOpenJobPostingParam();
};

document.addEventListener("turbolinks:load", setupJobPosting);
